import Axios from 'axios';


const urlPublikos = "https://publikosnode.baradinrtllc.com/"

// Helper Functions
const postData = async (data,urlRoot,urlExt) =>{
    const url = urlRoot + urlExt;
    const res = await Axios.post(url,data);
    console.log(res)
    return res.data;
}

const getData = async (urlRoot,urlExt) =>{
    const url = urlRoot + urlExt;
    const res = await Axios.get(url);
    return res.data;
}

export const searchHistory = async(searchString) =>{

    // will probably return list of related profiles/articles

    return []
    // const urlRoot = "https://petrosfa.baradinrtllc.com/"
    // const payload = {searchString}
    // const temp = await postData(payload,urlRoot, "getClosestCategories"); 
    // return temp
}

// export const getMtkProfiles = async() =>{

//     const urlRoot = urlPublikos
//     const payload = {key:"mtkProfiles"}
//     const temp = await postData(payload,urlRoot, "getData");
//     return temp["data"]
// }

export const submitFormData = async(data) =>{

    const urlRoot = "https://petrosnodepublic.carderocksprings.tech/"
    // const urlRoot = "http://10.0.1.15:3511/"
    const payload = data
    const temp = await postData(payload,urlRoot, "csChatSignUp");
}

export const getDataAll = async() =>{

    const urlRoot = urlPublikos
    const payload = {key:"qrCodesMap2026CSChat"}
    const temp = await postData(payload,urlRoot, "getData");

    console.log(temp)
    return temp["data"]
}

